import React from 'react';

import { useGetTaskUpdatesQuery } from '@/services/api';
import { TaskUpdate } from '@/services/types/client-intake-types';

interface LatestTaskUpdateProps {
  matterId: string;
  taskId: string;
}

export const LatestTaskUpdate: React.FC<LatestTaskUpdateProps> = ({
  matterId,
  taskId,
}) => {
  const {
    data: updates = [],
    isLoading,
    isError,
  } = useGetTaskUpdatesQuery(
    { matterId, taskId },
    { skip: !matterId || !taskId },
  );

  if (isLoading || isError || updates.length === 0) {
    return null;
  }

  // Find most recent by created_at
  const latest: TaskUpdate | undefined = updates.reduce<TaskUpdate | undefined>(
    (acc, curr) => {
      if (!acc) return curr;
      return new Date(curr.created_at) > new Date(acc.created_at) ? curr : acc;
    },
    undefined,
  );

  if (!latest?.update) return null;

  return (
    <p className="mt-1 text-xs text-gray-600 truncate" title={latest.update}>
      {latest.update}
    </p>
  );
};
